import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, ChevronRight, CornerDownRight } from 'lucide-react';

export const CallRoutingToolPreview = ({ api, subAccountId, agentId, routingHref, textPrimary, textSecondary }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get(`/api/sub-accounts/${subAccountId}/agents/${agentId}/call-routing-menu`)
      .then((r) => setData(r.data)).catch(() => setData({ flow: null }));
  }, [api, subAccountId, agentId]);

  if (!data) return <p className={`mt-3 text-xs ${textSecondary}`}>Loading routing menu…</p>;
  const stop = (e) => e.stopPropagation();
  if (!data.flow) {
    return (
      <div onClick={stop} className="mt-3 flex items-start gap-2 p-3 rounded-lg border border-amber-400/30 bg-amber-400/10" data-testid="route-call-no-flow">
        <AlertTriangle size={14} className="text-amber-400 mt-0.5 shrink-0" />
        <p className="text-xs text-amber-300">No routing flow uses this agent yet. In Call Routing, pick this agent in a flow's Start step. <Link to={routingHref} className="underline">Open Call Routing</Link></p>
      </div>
    );
  }
  const opts = data.menu?.options || [];
  return (
    <div onClick={stop} className="mt-3 rounded-lg border border-white/10 bg-white/[0.03] p-3.5" data-testid="route-call-preview">
      <div className="flex items-center justify-between gap-3 mb-2">
        <p className={`text-[11px] uppercase tracking-wider ${textSecondary}`}>Following · <span className={textPrimary}>{data.flow.name}</span>{data.flow.enabled ? '' : ' (off)'}</p>
        <Link to={`${routingHref}/${data.flow.flow_id}/canvas`} className="inline-flex items-center gap-1 text-xs font-medium text-teal-400 hover:underline" data-testid="route-call-edit-link">
          Edit in Call Routing <ChevronRight size={12} />
        </Link>
      </div>
      {opts.length === 0 ? <p className={`text-xs ${textSecondary}`}>This flow has no menu options yet. Add a Menu step after Start.</p> : (
        <ul className="space-y-1.5">
          {opts.map((o) => (
            <li key={`${o.key}-${o.label}`} className="flex items-center gap-2 text-sm" data-testid={`route-call-option-${o.key}`}>
              <span className="w-6 h-6 rounded-md bg-teal-400/10 text-teal-400 text-xs font-semibold flex items-center justify-center">{o.key}</span>
              <span className={textPrimary}>{o.label}</span>
              {o.submenu && <span className={`inline-flex items-center gap-1 text-[11px] ${textSecondary}`}><CornerDownRight size={11} />sub-menu</span>}
              {!o.connected && <span className="text-[11px] text-amber-400">not connected</span>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CallRoutingToolPreview;
